import { Laboratory } from './laboratory';
import { PaginationData } from './pagination-data.model';

export class LaboratoryChangeRequest {
  id: number;
  name?: string;
  requestedBy: string;
  requestType: string; // TODO: Enum
  requestStatus: string; // TODO: Enum
  requestInfo: string;
  actionedBy: string;
  createdAt: Date;
  updatedAt: Date;
  updateDifferences: string;
  organisationName: string;
}

export class LaboratoryIndexResponse {
  laboratoryChangeRequests: LaboratoryChangeRequest[];
  paginationData: PaginationData;
}

export class UserChangeRequest {
  id: number;
  userId: number;
  firstName: string;
  lastName: string;
  userEmail: string;
  labIds: number[];
  userLaboratories: Laboratory[];
  requestedBy: string;
  requestType: string; // TODO: Enum
  requestStatus: string; // TODO: Enum
  requestInfo: string;
  actionedBy: string;
  createdAt: Date;
  updatedAt: Date;
  roleName: string;
  roleId: number;
  updateDifferences: string;
  organisationName: string;
}

export class UserIndexResponse {
  userChangeRequests: UserChangeRequest[];
  paginationData: PaginationData;
}

export class DeviceChangeRequest {
  id: number;
  deviceId: number;
  name: string;
  macAddress: string;
  laboratoryName: string;
  deviceModuleIds: number[];
  requestedBy: string;
  requestType: string; // TODO: Enum
  requestStatus: string; // TODO: Enum
  requestInfo: string;
  actionedBy: string;
  createdAt: Date;
  updatedAt: Date;
  updateDifferences: string;
  pumpTubeLength: number;
  organisationName: string;
}

export class DeviceIndexResponse {
  deviceChangeRequests: DeviceChangeRequest[];
  paginationData: PaginationData;
}

export class OrganisationChangeRequest {
  id: number;
  organisationName: string;
  licenceType: string;
  superUserFirstName: string;
  superUserLastName: string;
  superUserEmail: string;
  requestedBy: string;
  requestType: string; // TODO: Enum
  requestStatus: string; // TODO: Enum
  requestInfo: string;
  actionedBy: string;
  createdAt: Date;
  updatedAt: Date;
  updateDifferences: string;
}

export class OrganisationIndexResponse {
  organisationChangeRequests: OrganisationChangeRequest[];
  paginationData: PaginationData;
}

export class ApprovalUpdate {
  id: number;
  requestStatus: RequestStatus;
  requestInfo?: string;
}

export enum RequestType {
  Create = 1,
  Update = 2,
  Delete = 3,
}

export enum RequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export class ChangeRequest {
  id: number;
  requestType: string;
  updateDifferences: string;
  organisationName: string;
  requestStatus: string;
  requestedBy: string;
  createdAt: Date;
  actionedBy: string;
  updatedAt: Date;
  firstName?: string;
  lastName?: string;
  userEmail?: string;
  superUserFirstName?: string;
  superUserLastName?: string;
  superUserEmail?: string;
  roleId?: number;
  laboratoryName?: string;
  name?: string;
  macAddress?: string;
  pumpTubeLength?: number;
  requestInfo?: string;
  userLaboratories?: Laboratory[];
  licenseType: string;

  constructor(
    id: number,
    requestType: string,
    updateDifferences: string,
    organisationName: string,
    requestStatus: string,
    requestedBy: string,
    createdAt: Date,
    actionedBy: string,
    updatedAt: Date,
    firstName?: string,
    lastName?: string,
    userEmail?: string,
    superUserFirstName?: string,
    superUserLastName?: string,
    superUserEmail?: string,
    roleId?: number,
    laboratoryName?: string,
    name?: string,
    macAddress?: string,
    pumpTubeLength?: number,
    requestInfo?: string,
    userLaboratories?: Laboratory[],
    licenseType?: string,
  ) {
    this.id = id;
    this.requestType = requestType;
    this.updateDifferences = updateDifferences;
    this.organisationName = organisationName;
    this.requestStatus = requestStatus;
    this.requestedBy = requestedBy;
    this.createdAt = createdAt;
    this.actionedBy = actionedBy;
    this.updatedAt = updatedAt;
    this.firstName = firstName;
    this.lastName = lastName;
    this.userEmail = userEmail;
    this.superUserFirstName = superUserFirstName;
    this.superUserLastName = superUserLastName;
    this.superUserEmail = superUserEmail;
    this.roleId = roleId;
    this.laboratoryName = laboratoryName;
    this.name = name;
    this.macAddress = macAddress;
    this.pumpTubeLength = pumpTubeLength;
    this.requestInfo = requestInfo;
    this.userLaboratories = userLaboratories;
    this.licenseType = licenseType;
  }
}
